import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortsPopupComponent } from './ports-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PortsPopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ],
  exports:[
    PortsPopupComponent
  ]
})
export class PortsPopupModule { }
